import { render, staticRenderFns } from "./update_application.vue?vue&type=template&id=b1c0f2c2&"
import script from "./update_application.vue?vue&type=script&lang=js&"
export * from "./update_application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports